// // // // import React, { useEffect, useState, createContext } from 'react';
// // // // import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // // // // --- Page & Layout Components ---
// // // // import DashboardPage from './component/pages/Dashboard/Dashboard';
// // // // import Sidebar from './component/pages/Dashboard/Sidebar';
// // // // import Navbar from './component/Navbar/Navbar';
// // // // import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// // // // import TaskDetailPage from './component/Task/TaskDetailPage';
// // // // import TasksListPage from './component/Task/TasksListPage';
// // // // import CreateTaskPage from './component/Task/CreateTaskPage';
// // // // import Project from './component/pages/Dashboard/Project/Project';
// // // // import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// // // // import Team from './component/Organization/Team';
// // // // import TeamManagement from './component/Organization/TeamManagement';
// // // // import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// // // // import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// // // // import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// // // // import AdminManager from './component/AdminManager/AdminManager.js';
// // // // import FloatingActionButton from './component/common/FloatingActionButton';
// // // // import ReportsPage from '../src/component/Report/Report.js';
// // // // import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// // // // import './App.css';

// // // // // --- Create and export the RefreshContext ---
// // // // export const RefreshContext = createContext();

// // // // // --- REDIRECT URL ---
// // // // const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // // // // --- JWT PARSING HELPER ---
// // // // const parseJwt = (token) => {
// // // //     try {
// // // //         const base64Url = token.split('.')[1];
// // // //         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// // // //         const jsonPayload = decodeURIComponent(
// // // //             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
// // // //         );
// // // //         return JSON.parse(jsonPayload);
// // // //     } catch (error) {
// // // //         console.error('Auth Error: Failed to parse JWT.', error);
// // // //         return null;
// // // //     }
// // // // };

// // // // // --- HELPER COMPONENTS ---
// // // // const RedirectToLogin = ({ message }) => {
// // // //     useEffect(() => {
// // // //         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
// // // //     }, []);
// // // //     return (
// // // //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // // //             <h1>{message || 'Redirecting to Login...'}</h1>
// // // //         </div>
// // // //     );
// // // // };

// // // // const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // // // // --- NEW: Main Layout Component ---
// // // // // This component holds the persistent UI structure (Sidebar, Navbar)
// // // // // so it doesn't get remounted by the AuthHandler.
// // // // const MainLayout = () => {
// // // //     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
// // // //     const [refreshKey, setRefreshKey] = useState(0);

// // // //     const handleProfileUpdate = () => {
// // // //         setSidebarRefreshKey((prevKey) => prevKey + 1);
// // // //     };

// // // //     const triggerRefresh = () => {
// // // //         setRefreshKey((prevKey) => prevKey + 1);
// // // //     };

// // // //     return (
// // // //         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
// // // //             <div className="app-layout">
// // // //                 <Sidebar refreshKey={sidebarRefreshKey} />
// // // //                 <div className="main-content-area">
// // // //                     <Navbar /> {/* Navbar is now in a stable parent */}
// // // //                     <div className="page-content-wrapper">
// // // //                         <Routes>
// // // //                             <Route path="/" element={<DashboardPage />} />
// // // //                             <Route path="/dashboard" element={<DashboardPage />} />
// // // //                             <Route path="/tasks" element={<TasksListPage />} />
// // // //                             <Route path="/tasks/create" element={<CreateTaskPage />} />
// // // //                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />
// // // //                             <Route path="/assets" element={<Assets />} />
// // // //                             <Route path="/project" element={<Project />} />
// // // //                             <Route path="/organization/team" element={<Team />} />
// // // //                             <Route path="/organization/team-management" element={<TeamManagement />} />
// // // //                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
// // // //                             <Route path="/organization/common-master" element={<CommonMaster />} />
// // // //                             <Route path="/customers" element={<CustomerList />} />
// // // //                             <Route path="/customers/new" element={<CustomerForm />} />
// // // //                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />
// // // //                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
// // // //                             <Route path="/reports" element={<ReportsPage />} />
// // // //                             <Route path="/reports/settings" element={<ReportSettingsPage />} />
// // // //                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
// // // //                         </Routes>
// // // //                     </div>
// // // //                 </div>
// // // //                 <FloatingActionButton />
// // // //             </div>
// // // //         </RefreshContext.Provider>
// // // //     );
// // // // };

// // // // // --- AUTH HANDLER (Updated to render MainLayout) ---
// // // // const AuthHandler = ({ children }) => {
// // // //     const location = useLocation();
// // // //     const navigate = useNavigate();
// // // //     const [authStatus, setAuthStatus] = useState('PENDING');

// // // //     useEffect(() => {
// // // //         const searchParams = new URLSearchParams(location.search);
// // // //         const tokenFromUrl = searchParams.get('token');
// // // //         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

// // // //         if (tokenFromUrl && userDetailsEncodedFromUrl) {
// // // //             try {
// // // //                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
// // // //                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
// // // //                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
// // // //                 navigate(location.pathname, { replace: true, search: '' });
// // // //                 setAuthStatus('AUTHENTICATED');
// // // //             } catch (e) {
// // // //                 console.error('Auth Error: Failed to parse user details from URL.', e);
// // // //                 localStorage.clear();
// // // //                 setAuthStatus('FAILED');
// // // //             }
// // // //             return;
// // // //         }

// // // //         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
// // // //         if (tokenFromLocalStorage) {
// // // //             const decodedToken = parseJwt(tokenFromLocalStorage);
// // // //             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
// // // //                 localStorage.clear();
// // // //                 setAuthStatus('EXPIRED');
// // // //             } else {
// // // //                 setAuthStatus('AUTHENTICATED');
// // // //             }
// // // //         } else {
// // // //             setAuthStatus('FAILED');
// // // //         }
// // // //     }, [location, navigate]);

// // // //     if (authStatus === 'PENDING')
// // // //         return (
// // // //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // // //                 <h1>Verifying Session...</h1>
// // // //             </div>
// // // //         );
// // // //     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
// // // //     if (authStatus === 'FAILED') return <RedirectToLogin />;

// // // //     // When authenticated, render the children passed to it.
// // // //     return children;
// // // // };

// // // // // --- Main App Component (Now cleaner) ---
// // // // const App = () => {
// // // //     return (
// // // //         <BrowserRouter>
// // // //             <AuthHandler>
// // // //                 {/* The entire stable layout is now the child of AuthHandler */}
// // // //                 <MainLayout />
// // // //             </AuthHandler>
// // // //         </BrowserRouter>
// // // //     );
// // // // };

// // // // export default App;

// // // import React, { useEffect, useState, createContext } from 'react';
// // // import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // // // --- Page & Layout Components ---
// // // import DashboardPage from './component/pages/Dashboard/Dashboard';
// // // import Sidebar from './component/pages/Dashboard/Sidebar';
// // // import Navbar from './component/Navbar/Navbar';
// // // import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// // // import TaskDetailPage from './component/Task/TaskDetailPage';
// // // import TasksListPage from './component/Task/TasksListPage';
// // // import CreateTaskPage from './component/Task/CreateTaskPage';
// // // import Project from './component/pages/Dashboard/Project/Project';
// // // import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// // // import Team from './component/Organization/Team';
// // // import TeamManagement from './component/Organization/TeamManagement';
// // // import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// // // import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// // // import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// // // import AdminManager from './component/AdminManager/AdminManager.js';
// // // import FloatingActionButton from './component/common/FloatingActionButton';
// // // import ReportsPage from '../src/component/Report/Report.js';
// // // import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// // // import './App.css';

// // // // --- NEWLY ADDED: Imports for Work Order, Invoice, and Work Type ---
// // // import WorkOrder, { WorkOrderFormPage } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// // // import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// // // import Invoice, { InvoiceFormPage } from "./component/pages/Dashboard/Invoice/Invoice";
// // // // Assuming WorkTypePage is a new component you will create inside the CommonMaster folder
// // // // If it's part of CommonMaster itself, you can adjust the route's element prop.
// // // const WorkTypePage = () => <div style={{ padding: '20px' }}>Work Type Management Page</div>;

// // // // --- Create and export the RefreshContext ---
// // // export const RefreshContext = createContext();

// // // // --- REDIRECT URL ---
// // // const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // // // --- JWT PARSING HELPER ---
// // // const parseJwt = (token) => {
// // //     try {
// // //         const base64Url = token.split('.')[1];
// // //         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// // //         const jsonPayload = decodeURIComponent(
// // //             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
// // //         );
// // //         return JSON.parse(jsonPayload);
// // //     } catch (error) {
// // //         console.error('Auth Error: Failed to parse JWT.', error);
// // //         return null;
// // //     }
// // // };

// // // // --- HELPER COMPONENTS ---
// // // const RedirectToLogin = ({ message }) => {
// // //     useEffect(() => {
// // //         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
// // //     }, []);
// // //     return (
// // //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // //             <h1>{message || 'Redirecting to Login...'}</h1>
// // //         </div>
// // //     );
// // // };

// // // const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // // // --- Main Layout Component ---
// // // const MainLayout = () => {
// // //     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
// // //     const [refreshKey, setRefreshKey] = useState(0);

// // //     const handleProfileUpdate = () => {
// // //         setSidebarRefreshKey((prevKey) => prevKey + 1);
// // //     };

// // //     const triggerRefresh = () => {
// // //         setRefreshKey((prevKey) => prevKey + 1);
// // //     };

// // //     return (
// // //         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
// // //             <div className="app-layout">
// // //                 <Sidebar refreshKey={sidebarRefreshKey} />
// // //                 <div className="main-content-area">
// // //                     <Navbar />
// // //                     <div className="page-content-wrapper">
// // //                         <Routes>
// // //                             {/* --- Core Routes --- */}
// // //                             <Route path="/" element={<DashboardPage />} />
// // //                             <Route path="/dashboard" element={<DashboardPage />} />
// // //                             <Route path="/project" element={<Project />} />
// // //                             <Route path="/assets" element={<Assets />} />

// // //                             {/* --- Task Routes --- */}
// // //                             <Route path="/tasks" element={<TasksListPage />} />
// // //                             <Route path="/tasks/create" element={<CreateTaskPage />} />
// // //                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />

// // //                             {/* --- Customer Routes --- */}
// // //                             <Route path="/customers" element={<CustomerList />} />
// // //                             <Route path="/customers/new" element={<CustomerForm />} />
// // //                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />

// // //                             {/* --- NEW: Work Order Routes --- */}
// // //                             <Route path="/work-orders" element={<WorkOrder />} />
// // //                             <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
// // //                             <Route path="/work-orders/edit/:id" element={<WorkOrderFormPage />} />
// // //                             <Route path="/work-orders/:id" element={<WorkOrderView />} />

// // //                             {/* --- NEW: Invoice Routes --- */}
// // //                             <Route path="/invoices" element={<Invoice />} />
// // //                             <Route path="/invoices/new" element={<InvoiceFormPage />} />
// // //                             <Route path="/invoices/edit/:id" element={<InvoiceFormPage />} />
// // //                             <Route path="/invoices/:id" element={<InvoiceFormPage />} />

// // //                             {/* --- Organization Routes --- */}
// // //                             <Route path="/organization/team" element={<Team />} />
// // //                             <Route path="/organization/team-management" element={<TeamManagement />} />
// // //                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
// // //                             <Route path="/organization/common-master" element={<CommonMaster />} />
// // //                             {/* --- NEW: Work Type Route --- */}
// // //                             <Route path="/organization/work-type" element={<WorkTypePage />} />

// // //                             {/* --- Reports Routes --- */}
// // //                             <Route path="/reports" element={<ReportsPage />} />
// // //                             <Route path="/reports/settings" element={<ReportSettingsPage />} />

// // //                             {/* --- Settings & Auth Routes --- */}
// // //                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
// // //                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
// // //                         </Routes>
// // //                     </div>
// // //                 </div>
// // //                 <FloatingActionButton />
// // //             </div>
// // //         </RefreshContext.Provider>
// // //     );
// // // };

// // // // --- AUTH HANDLER ---
// // // const AuthHandler = ({ children }) => {
// // //     const location = useLocation();
// // //     const navigate = useNavigate();
// // //     const [authStatus, setAuthStatus] = useState('PENDING');

// // //     useEffect(() => {
// // //         const searchParams = new URLSearchParams(location.search);
// // //         const tokenFromUrl = searchParams.get('token');
// // //         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

// // //         if (tokenFromUrl && userDetailsEncodedFromUrl) {
// // //             try {
// // //                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
// // //                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
// // //                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
// // //                 navigate(location.pathname, { replace: true, search: '' });
// // //                 setAuthStatus('AUTHENTICATED');
// // //             } catch (e) {
// // //                 console.error('Auth Error: Failed to parse user details from URL.', e);
// // //                 localStorage.clear();
// // //                 setAuthStatus('FAILED');
// // //             }
// // //             return;
// // //         }

// // //         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
// // //         if (tokenFromLocalStorage) {
// // //             const decodedToken = parseJwt(tokenFromLocalStorage);
// // //             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
// // //                 localStorage.clear();
// // //                 setAuthStatus('EXPIRED');
// // //             } else {
// // //                 setAuthStatus('AUTHENTICATED');
// // //             }
// // //         } else {
// // //             setAuthStatus('FAILED');
// // //         }
// // //     }, [location, navigate]);

// // //     if (authStatus === 'PENDING')
// // //         return (
// // //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// // //                 <h1>Verifying Session...</h1>
// // //             </div>
// // //         );
// // //     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
// // //     if (authStatus === 'FAILED') return <RedirectToLogin />;

// // //     return children;
// // // };

// // // // --- Main App Component ---
// // // const App = () => {
// // //     return (
// // //         <BrowserRouter>
// // //             <AuthHandler>
// // //                 <MainLayout />
// // //             </AuthHandler>
// // //         </BrowserRouter>
// // //     );
// // // };

// // // export default App;

// // import React, { useEffect, useState, createContext } from 'react';
// // import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // // --- Page & Layout Components ---
// // import DashboardPage from './component/pages/Dashboard/Dashboard';
// // import Sidebar from './component/pages/Dashboard/Sidebar';
// // import Navbar from './component/Navbar/Navbar';
// // import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// // import TaskDetailPage from './component/Task/TaskDetailPage';
// // import TasksListPage from './component/Task/TasksListPage';
// // import CreateTaskPage from './component/Task/CreateTaskPage';
// // import Project from './component/pages/Dashboard/Project/Project';
// // import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// // import Team from './component/Organization/Team';
// // import TeamManagement from './component/Organization/TeamManagement';
// // import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// // import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// // import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// // import AdminManager from './component/AdminManager/AdminManager.js';
// // import FloatingActionButton from './component/common/FloatingActionButton';
// // import ReportsPage from '../src/component/Report/Report.js';
// // import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// // import './App.css';

// // // --- NEWLY ADDED & CONSOLIDATED IMPORTS ---
// // import WorkOrder, { WorkOrderFormPage } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// // import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// // import Invoice, { InvoiceFormPage } from "./component/pages/Dashboard/Invoice/Invoice";
// // import WorkType, { WorkTypeFormPage } from "../src/component/pages/Dashboard/WorkType/WorkType.js"; // Added this import

// // // --- Create and export the RefreshContext ---
// // export const RefreshContext = createContext();

// // // --- REDIRECT URL (Corrected) ---
// // const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // // --- JWT PARSING HELPER ---
// // const parseJwt = (token) => {
// //     try {
// //         const base64Url = token.split('.')[1];
// //         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
// //         const jsonPayload = decodeURIComponent(
// //             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
// //         );
// //         return JSON.parse(jsonPayload);
// //     } catch (error){
// //         console.error('Auth Error: Failed to parse JWT.', error);
// //         return null;
// //     }
// // };

// // // --- HELPER COMPONENTS ---
// // const RedirectToLogin = ({ message }) => {
// //     useEffect(() => {
// //         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
// //     }, []);
// //     return (
// //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// //             <h1>{message || 'Redirecting to Login...'}</h1>
// //         </div>
// //     );
// // };

// // const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // // --- Main Layout Component ---
// // const MainLayout = () => {
// //     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
// //     const [refreshKey, setRefreshKey] = useState(0);

// //     const handleProfileUpdate = () => {
// //         setSidebarRefreshKey((prevKey) => prevKey + 1);
// //     };

// //     const triggerRefresh = () => {
// //         setRefreshKey((prevKey) => prevKey + 1);
// //     };

// //     return (
// //         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
// //             <div className="app-layout">
// //                 <Sidebar refreshKey={sidebarRefreshKey} />
// //                 <div className="main-content-area">
// //                     <Navbar />
// //                     <div className="page-content-wrapper">
// //                         <Routes>
// //                             {/* --- Core Routes --- */}
// //                             <Route path="/" element={<DashboardPage />} />
// //                             <Route path="/dashboard" element={<DashboardPage />} />
// //                             <Route path="/project" element={<Project />} />
// //                             <Route path="/assets" element={<Assets />} />

// //                             {/* --- Task Routes --- */}
// //                             <Route path="/tasks" element={<TasksListPage />} />
// //                             <Route path="/tasks/create" element={<CreateTaskPage />} />
// //                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />

// //                             {/* --- Customer Routes --- */}
// //                             <Route path="/customers" element={<CustomerList />} />
// //                             <Route path="/customers/new" element={<CustomerForm />} />
// //                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />

// //                             {/* --- Work Order Routes (View and Edit are included) --- */}
// //                             <Route path="/work-orders" element={<WorkOrder />} />
// //                             <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
// //                             <Route path="/work-orders/edit/:id" element={<WorkOrderFormPage />} />
// //                             <Route path="/work-orders/:id" element={<WorkOrderView />} />

// //                             {/* --- Invoice Routes --- */}
// //                             <Route path="/invoices" element={<Invoice />} />
// //                             <Route path="/invoices/new" element={<InvoiceFormPage />} />
// //                             <Route path="/invoices/edit/:id" element={<InvoiceFormPage />} />
// //                             <Route path="/invoices/:id" element={<InvoiceFormPage />} />

// //                             {/* --- Organization Routes --- */}
// //                             <Route path="/organization/team" element={<Team />} />
// //                             <Route path="/organization/team-management" element={<TeamManagement />} />
// //                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
// //                             <Route path="/organization/common-master" element={<CommonMaster />} />

// //                             {/* --- NEW: Work Type Routes (Added from other file) --- */}
// //                             <Route path="/organization/work-types" element={<WorkType />} />
// //                             <Route path="/organization/work-types/new" element={<WorkTypeFormPage />} />
// //                             <Route path="/organization/work-types/edit/:rowId" element={<WorkTypeFormPage />} />

// //                             {/* --- Reports Routes --- */}
// //                             <Route path="/reports" element={<ReportsPage />} />
// //                             <Route path="/reports/settings" element={<ReportSettingsPage />} />

// //                             {/* --- Settings & Auth Routes --- */}
// //                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
// //                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
// //                         </Routes>
// //                     </div>
// //                 </div>
// //                 <FloatingActionButton />
// //             </div>
// //         </RefreshContext.Provider>
// //     );
// // };

// // // --- AUTH HANDLER ---
// // const AuthHandler = ({ children }) => {
// //     const location = useLocation();
// //     const navigate = useNavigate();
// //     const [authStatus, setAuthStatus] = useState('PENDING');

// //     useEffect(() => {
// //         const searchParams = new URLSearchParams(location.search);
// //         const tokenFromUrl = searchParams.get('token');
// //         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

// //         if (tokenFromUrl && userDetailsEncodedFromUrl) {
// //             try {
// //                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
// //                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
// //                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
// //                 navigate(location.pathname, { replace: true, search: '' });
// //                 setAuthStatus('AUTHENTICATED');
// //             } catch (e) {
// //                 console.error('Auth Error: Failed to parse user details from URL.', e);
// //                 localStorage.clear();
// //                 setAuthStatus('FAILED');
// //             }
// //             return;
// //         }

// //         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
// //         if (tokenFromLocalStorage) {
// //             const decodedToken = parseJwt(tokenFromLocalStorage);
// //             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
// //                 localStorage.clear();
// //                 setAuthStatus('EXPIRED');
// //             } else {
// //                 setAuthStatus('AUTHENTICATED');
// //             }
// //         } else {
// //             setAuthStatus('FAILED');
// //         }
// //     }, [location, navigate]);

// //     if (authStatus === 'PENDING')
// //         return (
// //             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
// //                 <h1>Verifying Session...</h1>
// //             </div>
// //         );
// //     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
// //     if (authStatus === 'FAILED') return <RedirectToLogin />;

// //     return children;
// // };

// // // --- Main App Component ---
// // const App = () => {
// //     return (
// //         <BrowserRouter>
// //             <AuthHandler>
// //                 <MainLayout />
// //             </AuthHandler>
// //         </BrowserRouter>
// //     );
// // };

// // export default App;

// import React, { useEffect, useState, createContext } from 'react';
// import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// // --- Page & Layout Components ---
// import DashboardPage from './component/pages/Dashboard/Dashboard';
// import Sidebar from './component/pages/Dashboard/Sidebar';
// import Navbar from './component/Navbar/Navbar';
// import SettingPageMain from './component/pages/Dashboard/setting/pages/SettingPageMain';
// import TaskDetailPage from './component/Task/TaskDetailPage';
// import TasksListPage from './component/Task/TasksListPage';
// import CreateTaskPage from './component/Task/CreateTaskPage';
// import Project from './component/pages/Dashboard/Project/Project';
// import Assets from './component/pages/Dashboard/AssetsModule/Assets';
// import Team from './component/Organization/Team';
// import TeamManagement from './component/Organization/TeamManagement';
// import CommonMaster from '../src/component/Common_master/CommonMaster.js';
// import CustomerList from './component/pages/Dashboard/Customer/customer-list.jsx';
// import CustomerForm from './component/pages/Dashboard/Customer/form.jsx';
// import AdminManager from './component/AdminManager/AdminManager.js';
// import FloatingActionButton from './component/common/FloatingActionButton';
// import ReportsPage from '../src/component/Report/Report.js';
// import ReportSettingsPage from '../src/component/Report/Reportsetting.js';
// import './App.css';

// // --- NEWLY ADDED & CONSOLIDATED IMPORTS ---
// import WorkOrder, { WorkOrderFormPage } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// import Invoice, { InvoiceFormPage } from "./component/pages/Dashboard/Invoice/Invoice";
// import WorkType, { WorkTypeFormPage } from "../src/component/pages/Dashboard/WorkType/WorkType.js";

// // --- Create and export the RefreshContext ---
// export const RefreshContext = createContext();

// // --- REDIRECT URL (Corrected) ---
// const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // --- JWT PARSING HELPER ---
// const parseJwt = (token) => {
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (error){
//         console.error('Auth Error: Failed to parse JWT.', error);
//         return null;
//     }
// };

// // --- HELPER COMPONENTS ---
// const RedirectToLogin = ({ message }) => {
//     useEffect(() => {
//         window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
//     }, []);
//     return (
//         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//             <h1>{message || 'Redirecting to Login...'}</h1>
//         </div>
//     );
// };

// const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // --- Main Layout Component ---
// const MainLayout = () => {
//     const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
//     const [refreshKey, setRefreshKey] = useState(0);

//     const handleProfileUpdate = () => {
//         setSidebarRefreshKey((prevKey) => prevKey + 1);
//     };

//     const triggerRefresh = () => {
//         setRefreshKey((prevKey) => prevKey + 1);
//     };

//     return (
//         <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
//             <div className="app-layout">
//                 <Sidebar refreshKey={sidebarRefreshKey} />
//                 <div className="main-content-area">
//                     <Navbar />
//                     <div className="page-content-wrapper">
//                         <Routes>
//                             {/* --- Core Routes --- */}
//                             <Route path="/" element={<DashboardPage />} />
//                             <Route path="/dashboard" element={<DashboardPage />} />
//                             <Route path="/project" element={<Project />} />
//                             <Route path="/assets" element={<Assets />} />

//                             {/* --- Task Routes --- */}
//                             <Route path="/tasks" element={<TasksListPage />} />
//                             <Route path="/tasks/create" element={<CreateTaskPage />} />
//                             <Route path="/tasks/:taskId" element={<TaskDetailPage />} />

//                             {/* --- Customer Routes --- */}
//                             <Route path="/customers" element={<CustomerList />} />
//                             <Route path="/customers/new" element={<CustomerForm />} />
//                             <Route path="/customers/edit/:rowId" element={<CustomerForm />} />

//                             {/* --- Work Order Routes (View and Edit are included) --- */}
//                             <Route path="/work-orders" element={<WorkOrder />} />
//                             <Route path="/work-orders/new" element={<WorkOrderFormPage />} />

//                             {/* --- THIS IS THE CORRECTED ROUTE --- */}
//                             <Route path="/work-orders/:id/edit" element={<WorkOrderFormPage />} />

//                             <Route path="/work-orders/:id" element={<WorkOrderView />} />

//                             {/* --- Invoice Routes --- */}
//                             <Route path="/invoices" element={<Invoice />} />
//                             <Route path="/invoices/new" element={<InvoiceFormPage />} />
//                             <Route path="/invoices/edit/:id" element={<InvoiceFormPage />} />
//                             <Route path="/invoices/:id" element={<InvoiceFormPage />} />

//                             {/* --- Organization Routes --- */}
//                             <Route path="/organization/team" element={<Team />} />
//                             <Route path="/organization/team-management" element={<TeamManagement />} />
//                             <Route path="/organization/user-management" element={<AdminManager onProfileUpdate={handleProfileUpdate} />} />
//                             <Route path="/organization/common-master" element={<CommonMaster />} />

//                             {/* --- Work Type Routes --- */}
//                             <Route path="/organization/work-types" element={<WorkType />} />
//                             <Route path="/organization/work-types/new" element={<WorkTypeFormPage />} />
//                             <Route path="/organization/work-types/edit/:rowId" element={<WorkTypeFormPage />} />

//                             {/* --- Reports Routes --- */}
//                             <Route path="/reports" element={<ReportsPage />} />
//                             <Route path="/reports/settings" element={<ReportSettingsPage />} />

//                             {/* --- Settings & Auth Routes --- */}
//                             <Route path="/settings/*" element={<SettingPageMain onProfileUpdate={handleProfileUpdate} />} />
//                             <Route path="/login" element={<ZTaskLoginPlaceholder />} />
//                         </Routes>
//                     </div>
//                 </div>
//                 <FloatingActionButton />
//             </div>
//         </RefreshContext.Provider>
//     );
// };

// // --- AUTH HANDLER ---
// const AuthHandler = ({ children }) => {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [authStatus, setAuthStatus] = useState('PENDING');

//     useEffect(() => {
//         const searchParams = new URLSearchParams(location.search);
//         const tokenFromUrl = searchParams.get('token');
//         const userDetailsEncodedFromUrl = searchParams.get('userDetails');

//         if (tokenFromUrl && userDetailsEncodedFromUrl) {
//             try {
//                 const userDetails = JSON.parse(decodeURIComponent(userDetailsEncodedFromUrl));
//                 localStorage.setItem('zTaskAuthToken', tokenFromUrl);
//                 localStorage.setItem('zTaskUserDetails', JSON.stringify(userDetails));
//                 navigate(location.pathname, { replace: true, search: '' });
//                 setAuthStatus('AUTHENTICATED');
//             } catch (e) {
//                 console.error('Auth Error: Failed to parse user details from URL.', e);
//                 localStorage.clear();
//                 setAuthStatus('FAILED');
//             }
//             return;
//         }

//         const tokenFromLocalStorage = localStorage.getItem('zTaskAuthToken');
//         if (tokenFromLocalStorage) {
//             const decodedToken = parseJwt(tokenFromLocalStorage);
//             if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
//                 localStorage.clear();
//                 setAuthStatus('EXPIRED');
//             } else {
//                 setAuthStatus('AUTHENTICATED');
//             }
//         } else {
//             setAuthStatus('FAILED');
//         }
//     }, [location, navigate]);

//     if (authStatus === 'PENDING')
//         return (
//             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//                 <h1>Verifying Session...</h1>
//             </div>
//         );
//     if (authStatus === 'EXPIRED') return <RedirectToLogin message="Your session has expired. Redirecting..." />;
//     if (authStatus === 'FAILED') return <RedirectToLogin />;

//     return children;
// };

// // --- Main App Component ---
// const App = () => {
//     return (
//         <BrowserRouter>
//             <AuthHandler>
//                 <MainLayout />
//             </AuthHandler>
//         </BrowserRouter>
//     );
// };

// export default App;

// import React, { useEffect, useState, createContext } from "react";
// import {
//   BrowserRouter,
//   Routes,
//   Route,
//   useLocation,
//   useNavigate,
// } from "react-router-dom";

// // --- Page & Layout Components ---
// import DashboardPage from "./component/pages/Dashboard/Dashboard";
// import Sidebar from "./component/pages/Dashboard/Sidebar";
// import Navbar from "./component/Navbar/Navbar";
// import SettingPageMain from "./component/pages/Dashboard/setting/pages/SettingPageMain";
// import Project from "./component/pages/Dashboard/Project/Project";
// import Assets from "./component/pages/Dashboard/AssetsModule/Assets";
// import Team from "./component/Organization/Team";
// import TeamManagement from "./component/Organization/TeamManagement";
// import CommonMaster from "../src/component/Common_master/CommonMaster.js";
// import CustomerList from "./component/pages/Dashboard/Customer/customer-list.jsx";
// import CustomerForm from "./component/pages/Dashboard/Customer/form.jsx";
// import AdminManager from "./component/AdminManager/AdminManager.js";
// import FloatingActionButton from "./component/common/FloatingActionButton";
// import ReportsPage from "../src/component/Report/Report.js";
// import ReportSettingsPage from "../src/component/Report/Reportsetting.js";
// import "./App.css";

// // --- Module-specific Imports ---
// import WorkOrder, {
//   WorkOrderFormPage,
// } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
// import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
// import Invoice, {
//   InvoiceFormPage,
// } from "./component/pages/Dashboard/Invoice/Invoice";
// import WorkType, {
//   WorkTypeFormPage,
// } from "../src/component/pages/Dashboard/WorkType/WorkType.js";
// import InvoicePrint from "./component/pages/Dashboard/Invoice/Print.js";

// // --- Create and export the RefreshContext ---
// export const RefreshContext = createContext();

// // --- REDIRECT URL ---
// const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// // --- JWT PARSING HELPER ---
// const parseJwt = (token) => {
//   try {
//     const base64Url = token.split(".")[1];
//     const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
//     const jsonPayload = decodeURIComponent(
//       atob(base64)
//         .split("")
//         .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
//         .join("")
//     );
//     return JSON.parse(jsonPayload);
//   } catch (error) {
//     console.error("Auth Error: Failed to parse JWT.", error);
//     return null;
//   }
// };

// // --- HELPER COMPONENTS ---
// const RedirectToLogin = ({ message }) => {
//   useEffect(() => {
//     window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
//   }, []);
//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//       }}
//     >
//       <h1>{message || "Redirecting to Login..."}</h1>
//     </div>
//   );
// };

// const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// // --- Main Layout Component ---
// const MainLayout = () => {
//   const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
//   const [refreshKey, setRefreshKey] = useState(0);

//   const handleProfileUpdate = () => {
//     setSidebarRefreshKey((prevKey) => prevKey + 1);
//   };

//   const triggerRefresh = () => {
//     setRefreshKey((prevKey) => prevKey + 1);
//   };

//   return (
//     <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
//       <div className="app-layout">
//         <Sidebar refreshKey={sidebarRefreshKey} />
//         <div className="main-content-area">
//           <Navbar />
//           <div className="page-content-wrapper">
//             <Routes>
//               {/* --- Core Routes --- */}
//               <Route path="/" element={<DashboardPage />} />
//               <Route path="/dashboard" element={<DashboardPage />} />
//               <Route path="/project" element={<Project />} />
//               <Route path="/assets" element={<Assets />} />

//               {/* --- Customer Routes --- */}
//               <Route path="/customers" element={<CustomerList />} />
//               <Route path="/customers/new" element={<CustomerForm />} />
//               <Route path="/customers/:rowId/edit" element={<CustomerForm />} />

//               {/* --- Work Order Routes (View and Edit are included) --- */}
//               <Route path="/work-orders" element={<WorkOrder />} />
//               <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
//               <Route
//                 path="/work-orders/:id/edit"
//                 element={<WorkOrderFormPage />}
//               />
//               <Route path="/work-orders/:id" element={<WorkOrderView />} />

//               {/* --- Invoice Routes --- */}
//               <Route path="/invoices" element={<Invoice />} />
//               <Route path="/invoices/new" element={<InvoiceFormPage />} />
//               <Route path="/invoices/:id/edit" element={<InvoiceFormPage />} />
//               <Route path="/invoices/:id" element={<InvoicePrint />} />

//               {/* --- Organization Routes --- */}
//               <Route path="/organization/team" element={<Team />} />
//               <Route
//                 path="/organization/team-management"
//                 element={<TeamManagement />}
//               />
//               <Route
//                 path="/organization/user-management"
//                 element={<AdminManager onProfileUpdate={handleProfileUpdate} />}
//               />
//               <Route
//                 path="/organization/common-master"
//                 element={<CommonMaster />}
//               />

//               {/* --- Work Type Routes --- */}
//               <Route path="/organization/work-types" element={<WorkType />} />
//               <Route
//                 path="/organization/work-types/new"
//                 element={<WorkTypeFormPage />}
//               />
//               <Route
//                 path="/organization/work-types/:rowId/edit"
//                 element={<WorkTypeFormPage />}
//               />

//               {/* --- Reports Routes --- */}
//               <Route path="/reports" element={<ReportsPage />} />
//               <Route
//                 path="/reports/settings"
//                 element={<ReportSettingsPage />}
//               />

//               {/* --- Settings & Auth Routes --- */}
//               <Route
//                 path="/settings/*"
//                 element={
//                   <SettingPageMain onProfileUpdate={handleProfileUpdate} />
//                 }
//               />
//               <Route path="/login" element={<ZTaskLoginPlaceholder />} />
//             </Routes>
//           </div>
//         </div>
//       </div>
//     </RefreshContext.Provider>
//   );
// };

// // --- AUTH HANDLER ---
// const AuthHandler = ({ children }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [authStatus, setAuthStatus] = useState("PENDING");

//   useEffect(() => {
//     const searchParams = new URLSearchParams(location.search);
//     const tokenFromUrl = searchParams.get("token");
//     const userDetailsEncodedFromUrl = searchParams.get("userDetails");

//     if (tokenFromUrl && userDetailsEncodedFromUrl) {
//       try {
//         const userDetails = JSON.parse(
//           decodeURIComponent(userDetailsEncodedFromUrl)
//         );
//         localStorage.setItem("zTaskAuthToken", tokenFromUrl);
//         localStorage.setItem("zTaskUserDetails", JSON.stringify(userDetails));
//         navigate(location.pathname, { replace: true, search: "" });
//         setAuthStatus("AUTHENTICATED");
//       } catch (e) {
//         console.error("Auth Error: Failed to parse user details from URL.", e);
//         localStorage.clear();
//         setAuthStatus("FAILED");
//       }
//       return;
//     }

//     const tokenFromLocalStorage = localStorage.getItem("zTaskAuthToken");
//     if (tokenFromLocalStorage) {
//       const decodedToken = parseJwt(tokenFromLocalStorage);
//       if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
//         localStorage.clear();
//         setAuthStatus("EXPIRED");
//       } else {
//         setAuthStatus("AUTHENTICATED");
//       }
//     } else {
//       setAuthStatus("FAILED");
//     }
//   }, [location, navigate]);
//   //   alert("Auth Status: " + authStatus);

//   if (authStatus === "PENDING")
//     return (
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100vh",
//         }}
//       >
//         <h1>Verifying Session...</h1>
//       </div>
//     );
//   if (authStatus === "EXPIRED")
//     return (
//       <RedirectToLogin message="Your session has expired. Redirecting..." />
//     );
//   if (authStatus === "FAILED") return <RedirectToLogin />;

//   return children;
// };

// // --- Main App Component ---
// const App = () => {
//   return (
//     <BrowserRouter>
//       <AuthHandler>
//         <MainLayout />
//       </AuthHandler>
//     </BrowserRouter>
//   );
// };

// export default App;










import React, { useEffect, useState, createContext } from "react";
import "./shared-ui/crane-tokens.css";
import "./shared-ui/stitch-forms.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

// --- Page & Layout Components ---
import DashboardPage from "./component/pages/Dashboard/Dashboard";
import TaskDashboardPage from "./component/Task/TaskDashboardPage";
import Sidebar from "./component/pages/Dashboard/Sidebar";
import Navbar from "./component/Navbar/Navbar";
import SettingPageMain from "./component/pages/Dashboard/setting/pages/SettingPageMain";
import StitchTaskDetailPage from "./component/Task/StitchTaskDetailPage";
import StitchTasksPage from "./component/Task/StitchTasksPage";
import StitchCreateTaskPage from "./component/Task/StitchCreateTaskPage";
import Project from "./component/pages/Dashboard/Project/Project";
import StitchAssetsPage from "./component/pages/Dashboard/AssetsModule/StitchAssetsPage";
import AssetLifecyclePage from "./component/pages/Dashboard/AssetsModule/AssetLifecyclePage";
import AssetForm from "./component/pages/Dashboard/AssetsModule/AssetForm";
import {
  ComplianceDashboard,
  ComplianceVehiclePage,
  ComplianceLicencePage,
  ComplianceHistoryPage,
  ComplianceSavedVehiclesPage,
  ComplianceSavedLicencesPage,
} from "./component/pages/Compliance/CompliancePages";
import Team from "./component/Organization/Team";
import TeamManagement from "./component/Organization/TeamManagement";
import CommonMaster from "../src/component/Common_master/CommonMaster.js";
import CustomerList from "./component/pages/Dashboard/Customer/customer-list.jsx";
import CustomerForm from "./component/pages/Dashboard/Customer/form.jsx";
import CustomerLedgerView from "./component/pages/Dashboard/Customer/CustomerLedgerView.jsx";
import {
  getActiveApp,
  setActiveApp,
  inferAppFromPath,
  getCrossModuleRedirect,
} from "./config/activeModule";
import AdminManager from "./component/AdminManager/AdminManager.js";
import FloatingActionButton from "./component/common/FloatingActionButton";
import ReportsPage from "../src/component/Report/Report.js";
import ReportSettingsPage from "../src/component/Report/Reportsetting.js";
import MaintenanceReportsPage from "../src/component/Report/MaintenanceReportsPage.js";
import "./App.css";

// --- Module-specific Imports ---
import { WorkOrderFormPage } from "./component/pages/Dashboard/WorkOrder/WorkOrder";
import WorkOrderView from "./component/pages/Dashboard/WorkOrder/View";
import StitchWorkOrdersPage from "./component/pages/Dashboard/WorkOrder/StitchWorkOrdersPage";
import { StitchWorkOrderPrintPage } from "./component/pages/Dashboard/WorkOrder/StitchWorkOrderForms";
import { InvoiceFormPage } from "./component/pages/Dashboard/Invoice/Invoice";
import StitchInvoicesPage from "./component/pages/Dashboard/Invoice/StitchInvoicesPage";
import { StitchInvoicePrintPage } from "./component/pages/Dashboard/Invoice/StitchInvoiceForms";
import WorkType, {
  WorkTypeFormPage,
} from "../src/component/pages/Dashboard/WorkType/WorkType.js";
import ErrorBoundary from "./component/ErrorBoundary.js";
import { StitchFormShell } from "./shared-ui/StitchFormShell";

// --- AR Module Imports ---
import DebitNote from "./component/pages/Dashboard/AR/DebitNote/DebitNote";
import CreditNote from "./component/pages/Dashboard/AR/CreditNote/CreditNote";
import Receipt from "./component/pages/Dashboard/AR/Receipt/Receipt";
import {
  StitchDebitNoteFormPage,
  StitchCreditNoteFormPage,
  StitchReceiptFormPage,
  StitchDebitNoteViewPage,
  StitchCreditNoteViewPage,
  StitchReceiptViewPage,
  StitchDebitNotePrintPage,
  StitchCreditNotePrintPage,
  StitchReceiptPrintPage,
} from "./component/pages/Dashboard/AR/StitchArForms";
import QuotationList, {
  QuotationForm,
  QuotationView,
} from "./component/pages/Dashboard/Quotation/QuotationPages";
import QuotationConvertWizard from "./component/pages/Dashboard/Quotation/QuotationConvertWizard";
import GlobalSearchPage from "./component/pages/Platform/GlobalSearchPage";
import AuditActivityPage from "./component/pages/Platform/AuditActivityPage";
import OpsDashboardPage from "./component/pages/Platform/OpsDashboardPage";
import AccessDeniedPage from "./component/pages/Platform/AccessDeniedPage";
import ApplicationsPage from "./component/pages/Platform/ApplicationsPage";
import AdminSettingsHubPage from "./component/pages/Platform/AdminSettingsHubPage";

// --- Create and export the RefreshContext ---
export const RefreshContext = createContext();

// --- REDIRECT URL ---
const ZTOOL_LOGIN_REDIRECT_URL = `${process.env.REACT_APP_ZTOOL_URL}/login`;

// --- JWT PARSING HELPER ---
const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Auth Error: Failed to parse JWT.", error);
    return null;
  }
};

// --- HELPER COMPONENTS ---
const RedirectToLogin = ({ message }) => {
  useEffect(() => {
    window.location.replace(ZTOOL_LOGIN_REDIRECT_URL);
  }, []);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>{message || "Redirecting to Login..."}</h1>
    </div>
  );
};

const ZTaskLoginPlaceholder = () => <RedirectToLogin />;

// --- Soft module isolation (ZTASK vs ZORDER vs …) ---
const ModuleGate = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const active = getActiveApp();
    const redirect = getCrossModuleRedirect(location.pathname, active);
    if (!redirect || redirect === location.pathname) return;

    // Deep-link / typed URL: adopt the module implied by the path instead of bouncing away.
    // Exception: ZCompliance stays sticky — never silently switch to ZTask/ZOrder from admin/ops links.
    const inferred = inferAppFromPath(location.pathname);
    if (active === "ZCOMPLIANCE") {
      navigate(redirect, { replace: true });
      return;
    }
    if (inferred && inferred !== active) {
      setActiveApp(inferred);
      return;
    }
    navigate(redirect, { replace: true });
  }, [location.pathname, navigate]);

  return children;
};

// --- Main Layout Component ---
const MainLayout = () => {
  const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleProfileUpdate = () => {
    setSidebarRefreshKey((prevKey) => prevKey + 1);
  };

  const triggerRefresh = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  return (
    <RefreshContext.Provider value={{ refreshKey, triggerRefresh }}>
      <div className="app-layout">
        <Sidebar refreshKey={sidebarRefreshKey} />
        <div className="main-content-area">
          <Navbar />
          <div className="page-content-wrapper">
            <ErrorBoundary>
            <ModuleGate>
            <Routes>
              {/* --- Core Routes --- */}
              <Route path="/" element={<TaskDashboardPage />} />
              <Route path="/dashboard" element={<TaskDashboardPage />} />
              <Route path="/order-dashboard" element={<DashboardPage />} />
              <Route path="/tasks" element={<StitchTasksPage />} />
              <Route path="/tasks/create" element={<StitchCreateTaskPage />} />
              <Route path="/tasks/:taskId" element={<StitchTaskDetailPage />} />
              <Route path="/project" element={<Project />} />
              <Route path="/assets" element={<StitchAssetsPage />} />
              <Route path="/assets/new" element={
                <StitchFormShell crumbs={["Operations", "ZAsset", "Asset"]} title="Asset form">
                  <AssetForm />
                </StitchFormShell>
              } />
              <Route path="/assets/:id" element={<AssetLifecyclePage />} />
              <Route path="/assets/:id/edit" element={
                <StitchFormShell crumbs={["Operations", "ZAsset", "Asset"]} title="Asset form">
                  <AssetForm />
                </StitchFormShell>
              } />

              {/* --- ZCompliance (isolated ULIP) --- */}
              <Route path="/compliance" element={<ComplianceDashboard />} />
              <Route path="/compliance/vehicle" element={<ComplianceVehiclePage />} />
              <Route path="/compliance/licence" element={<ComplianceLicencePage />} />
              <Route path="/compliance/history" element={<ComplianceHistoryPage />} />
              <Route path="/compliance/vehicles" element={<ComplianceSavedVehiclesPage />} />
              <Route path="/compliance/licences" element={<ComplianceSavedLicencesPage />} />

              {/* --- Customer Routes --- */}
              <Route path="/customers" element={<CustomerList />} />
              <Route path="/customers/new" element={<CustomerForm />} />
              <Route path="/customers/:rowId/edit" element={<CustomerForm />} />
              <Route path="/customers/:rowId/ledger" element={<CustomerLedgerView />} />

              {/* --- Work Order Routes (View and Edit are included) --- */}
              <Route path="/work-orders" element={<StitchWorkOrdersPage />} />
              <Route path="/work-orders/new" element={<WorkOrderFormPage />} />
              <Route
                path="/work-orders/:id/edit"
                element={<WorkOrderFormPage />}
              />
              <Route path="/work-orders/:id" element={<WorkOrderView />} />
              <Route path="/work-orders/:id/print" element={<StitchWorkOrderPrintPage />} />

              {/* --- Invoice Routes --- */}
              <Route path="/invoices" element={<StitchInvoicesPage />} />
              <Route path="/invoices/new" element={<InvoiceFormPage />} />
              <Route path="/invoices/:id/edit" element={<InvoiceFormPage />} />
              <Route path="/invoices/:id" element={<StitchInvoicePrintPage />} />
              <Route path="/invoice/print/:id" element={<StitchInvoicePrintPage />} />

              {/* --- AR Module Routes - Debit Notes --- */}
              <Route path="/ar/debit-notes" element={<DebitNote />} />
              <Route path="/ar/debit-notes/new" element={<StitchDebitNoteFormPage />} />
              <Route path="/ar/debit-notes/:id/edit" element={<StitchDebitNoteFormPage />} />
              <Route path="/ar/debit-notes/:id/print" element={<StitchDebitNotePrintPage />} />
              <Route path="/ar/debit-notes/:id" element={<StitchDebitNoteViewPage />} />

              {/* --- AR Module Routes - Credit Notes --- */}
              <Route path="/ar/credit-notes" element={<CreditNote />} />
              <Route path="/ar/credit-notes/new" element={<StitchCreditNoteFormPage />} />
              <Route path="/ar/credit-notes/:id/edit" element={<StitchCreditNoteFormPage />} />
              <Route path="/ar/credit-notes/:id/print" element={<StitchCreditNotePrintPage />} />
              <Route path="/ar/credit-notes/:id" element={<StitchCreditNoteViewPage />} />

              {/* --- AR Module Routes - Receipts --- */}
              <Route path="/ar/receipts" element={<Receipt />} />
              <Route path="/ar/receipts/new" element={<StitchReceiptFormPage />} />
              <Route path="/ar/receipts/:id/edit" element={<StitchReceiptFormPage />} />
              <Route path="/ar/receipts/:id/print" element={<StitchReceiptPrintPage />} />
              <Route path="/ar/receipts/:id" element={<StitchReceiptViewPage />} />

              {/* --- Quotations --- */}
              <Route path="/quotations" element={<QuotationList />} />
              <Route path="/quotations/new" element={<QuotationForm />} />
              <Route path="/quotations/:id/edit" element={<QuotationForm />} />
              <Route path="/quotations/:id/convert" element={<QuotationConvertWizard />} />
              <Route path="/quotations/:id" element={<QuotationView />} />

              {/* --- Platform UX (Stitch Phase 2/9) --- */}
              <Route path="/search" element={<GlobalSearchPage />} />
              <Route path="/audit" element={<AuditActivityPage />} />
              <Route path="/ops-dashboard" element={<OpsDashboardPage />} />
              <Route path="/access-denied" element={<AccessDeniedPage />} />
              <Route path="/platform/applications" element={<ApplicationsPage />} />
              <Route path="/platform/settings" element={<AdminSettingsHubPage />} />

              {/* --- Organization Routes --- */}
              <Route path="/organization/team" element={<Team />} />
              <Route
                path="/organization/team-management"
                element={<TeamManagement />}
              />
              <Route
                path="/organization/user-management"
                element={<AdminManager onProfileUpdate={handleProfileUpdate} />}
              />
              <Route
                path="/organization/common-master"
                element={<CommonMaster />}
              />
              <Route
                path="/organization/common-master/new"
                element={<CommonMaster />}
              />
              <Route
                path="/organization/common-master/edit/:id"
                element={<CommonMaster />}
              />
              {/* Legacy short paths used by older Common Master navigation */}
              <Route path="/common-master" element={<CommonMaster />} />
              <Route path="/common-master/new" element={<CommonMaster />} />
              <Route path="/common-master/edit/:id" element={<CommonMaster />} />

              {/* --- Work Type Routes --- */}
              <Route path="/organization/work-types" element={<WorkType />} />
              <Route
                path="/organization/work-types/new"
                element={
                  <StitchFormShell crumbs={["Administration", "Organization", "Work Types"]} title="Work type form">
                    <WorkTypeFormPage />
                  </StitchFormShell>
                }
              />
              <Route
                path="/organization/work-types/:rowId/edit"
                element={
                  <StitchFormShell crumbs={["Administration", "Organization", "Work Types"]} title="Work type form">
                    <WorkTypeFormPage />
                  </StitchFormShell>
                }
              />

              {/* --- Reports Routes --- */}
              <Route path="/reports" element={<ReportsPage />} />
              <Route
                path="/reports/settings"
                element={<ReportSettingsPage />}
              />
              <Route
                path="/reports/maintenance"
                element={<MaintenanceReportsPage />}
              />

              {/* --- Settings & Auth Routes --- */}
              <Route
                path="/settings/*"
                element={
                  <SettingPageMain onProfileUpdate={handleProfileUpdate} />
                }
              />
              <Route path="/login" element={<ZTaskLoginPlaceholder />} />
            </Routes>
            </ModuleGate>
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </RefreshContext.Provider>
  );
};

// --- AUTH HANDLER ---
const AuthHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [authStatus, setAuthStatus] = useState("PENDING");

  useEffect(() => {
    // Try to parse token from query string first (current auth system)
    const queryParams = new URLSearchParams(location.search);
    let tokenFromUrl = queryParams.get("token");
    let userDetailsEncodedFromUrl = queryParams.get("userDetails");
    let appFromUrl = queryParams.get("app");

    // If not in query string, try hash (fallback for old auth system)
    if (!tokenFromUrl && location.hash) {
      const hash = location.hash.substring(1); // Remove the '#'
      const hashParams = new URLSearchParams(hash);
      tokenFromUrl = hashParams.get("token");
      userDetailsEncodedFromUrl = hashParams.get("userDetails");
      appFromUrl = appFromUrl || hashParams.get("app");
    }

    // Sticky product module for this browser tab (ZTASK / ZORDER / …)
    if (appFromUrl) {
      setActiveApp(appFromUrl);
    } else {
      const inferred = inferAppFromPath(location.pathname);
      if (inferred) {
        setActiveApp(inferred);
      } else if (!sessionStorage.getItem("zActiveApp")) {
        setActiveApp("ZTASK");
      }
    }

    // If token found in URL, store it and authenticate
    if (tokenFromUrl && userDetailsEncodedFromUrl) {
      try {
        const userDetails = JSON.parse(
          decodeURIComponent(userDetailsEncodedFromUrl)
        );
        localStorage.setItem("zTaskAuthToken", tokenFromUrl);
        localStorage.setItem("zTaskUserDetails", JSON.stringify(userDetails));
        setAuthStatus("AUTHENTICATED");
        // Clear URL parameters after storing token (delayed to prevent redirect loop)
        setTimeout(() => {
          navigate(location.pathname, { replace: true });
        }, 100);
      } catch (e) {
        console.error("Auth Error: Failed to parse user details from URL.", e);
        localStorage.clear();
        setAuthStatus("FAILED");
      }
      return;
    }

    // Check localStorage for existing token
    const tokenFromLocalStorage = localStorage.getItem("zTaskAuthToken");
    if (tokenFromLocalStorage) {
      const decodedToken = parseJwt(tokenFromLocalStorage);
      if (decodedToken && decodedToken.exp * 1000 < Date.now()) {
        localStorage.clear();
        setAuthStatus("EXPIRED");
      } else {
        setAuthStatus("AUTHENTICATED");
      }
    } else {
      setAuthStatus("FAILED");
    }
  }, [location, navigate]);
  //   alert("Auth Status: " + authStatus);

  if (authStatus === "PENDING")
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <h1>Verifying Session...</h1>
      </div>
    );
  if (authStatus === "EXPIRED")
    return (
      <RedirectToLogin message="Your session has expired. Redirecting..." />
    );
  if (authStatus === "FAILED") return <RedirectToLogin />;

  return children;
};

// --- Main App Component ---
const App = () => {
  return (
    <BrowserRouter>
      <AuthHandler>
        <MainLayout />
      </AuthHandler>
    </BrowserRouter>
  );
};

export default App;
